import React, { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';

const Grid = () => {
  const[products,setProducts]=useState([]);
  const[category,setCategory]=useState("Electronics");

  useEffect(()=>{
    const fetchData=async()=>{
      const response= await axios.get(`https://jsonplaceholder.typicode.com/users/`);
    console.log(response)
    setProducts(response.data);
    }
    fetchData();
  },[category]);
  return (
    <div className="container">
      <select onChange={(e)=>setCategory(e.target.value)} value={category}>
        <option value="electronics"> Electronics </option>
        <option value="dresses"> Dresses </option>
        <option value="food"> Food </option>
      </select>

      
        <ul>
          {
        products.map((product,index)=>{
          return(
            <li key={index}>
              {product.name}-{product.email}
            </li>
        )})}
        </ul>
     <h1>fetch data</h1>
    </div>
  );
};

export default Grid;
